import { __rest, __assign } from 'tslib';
import React from 'react';
import { SvgIcon } from '../SvgIcon/SvgIcon.esm.js';

var CaretRightIcon = function (_a) {
    var props = __rest(_a, []);
    return (React.createElement(SvgIcon, __assign({}, props, { viewBox: "0 0 8 12" }),
        React.createElement("path", { d: "M0.81434 0.315696C0.39522 0.734816 0.39522 1.41186 0.81434 1.83097L4.98404 6.00068L0.81434 10.1704C0.39522 10.5895 0.39522 11.2665 0.81434 11.6857C1.23346 12.1048 1.9105 12.1048 2.32962 11.6857L7.26233 6.75294C7.68145 6.33382 7.68145 5.65678 7.26233 5.23766L2.32962 0.304949C1.92125 -0.103424 1.23346 -0.103423 0.81434 0.315696Z" })));
};

export { CaretRightIcon };
//# sourceMappingURL=CaretRightIcon.esm.js.map
